export default {
  created() {
    this.$store.dispatch('saveOnboardingStage', this.$route.fullPath);
  },
};
